<template>
  <div :class="['address-container',!addAddress ? 'add':'']">
    <template v-if="addAddress">
      <div class="add-address">
        <div class="title">{{addressInfo.id ? '编辑地址' :'添加地址'}}</div>
        <Form class="edit" ref="formValidate" :model="addressInfo" :rules="ruleValidate">
          <FormItem prop="username" class="edit-item">
            <div class="data">
              <div class="label">姓名*</div>
              <Input type="text" v-model="addressInfo.username" />
            </div>
          </FormItem>
          <FormItem prop="address" class="edit-item" v-if="data.length<=0">
            <div class="data">
              <div class="label">省/市/区*</div>
              <Input type="text" readonly v-model="addressInfo.address" />
            </div>
          </FormItem>
          <FormItem prop="address" class="edit-item" v-else>
            <div class="data">
              <div class="label">省/市/区*</div>
              <Cascader
                filterable
                style="width:100%"
                v-model="addressInfo.address"
                :data="data"
                @on-change="changeTest"
              ></Cascader>
            </div>
          </FormItem>

          <FormItem prop="detail" class="edit-item">
            <div class="data">
              <div class="label">地址栏*</div>
              <Input type="text" v-model="addressInfo.detail" />
            </div>
          </FormItem>
          <FormItem class="edit-item two">
            <div class="data">
              <div class="label">邮编</div>
              <Input type="number" :maxlength="6" v-model="addressInfo.emailcode" />
            </div>
          </FormItem>
          <FormItem prop="phone" class="edit-item two phone">
            <div class="data">
              <div class="label">电话*</div>
              <Input type="number" v-model="addressInfo.phone" />
            </div>
            <div class="des">如果我们需要就您的订单与您联系</div>
          </FormItem>
          <FormItem class="edit-item saves">
            <div class="save">
              <div class="kuang" @click="chooseFirstChooseArrdess">
                <img
                  class="img"
                  v-if="addressInfo.firstChooseArrdess"
                  src="../assets/image/icon/close.svg"
                />
              </div>
              <div class="text">设为首选收货地址</div>
            </div>
          </FormItem>

          <FormItem class="edit-item two actions">
            <div class="data">
              <div class="btn canle-btn" @click="addAddress = false">取消</div>
            </div>
          </FormItem>
          <FormItem class="edit-item two actions save">
            <div class="data">
              <div class="btn" @click="handleSubmit('formValidate')">
                <div>保存修改</div>
                <img class="icon" src="../assets/image/icon/shop-cart-right.svg" />
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </template>
    <template v-else>
      <div class="title">地址簿</div>
      <div class="small_loading" v-if="loading">
        <img src="https://static.getconnectplus.com/tb_webassets/tb_small_loading.gif" />
      </div>
      <div class="address-list" v-else>
        <template v-if="addressList.length<=0">
          <div class="no-data">您暂未设置地址簿</div>
          <div class="action-btn">
            <div class="btn" @click="addAddressInfo()">
              <div>添加新地址</div>
              <img class="icon" src="../assets/image/icon/shop-cart-right.svg" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="address-item" v-for="(item,index) in addressList" :key="index">
            <div class="save-address" v-if="item.default">
              <div>首选收货地址</div>
            </div>
            <div class="save-address not-default" v-else></div>
            <div class="address-info">
              <div class="address-left">
                <div>
                  <div class="user-name">{{item.name}}</div>
                  <div class="user-address">
                    <span>{{item.province}}</span>
                    <span>{{item.city}}</span>
                    <span>{{item.district}},</span>

                    <span>{{item.detailAddress}}</span>
                  </div>
                  <div class="user-area">{{item.postCode}}</div>
                </div>
              </div>
              <div class="address-right">
                <div class="del-tips" v-if="isDel&&chooseindex == index">
                  <div>您确定吗？</div>
                  <div>
                    <span class="span1" @click="deleteAddress()">是</span>
                    <span class="span2">或</span>
                    <span class="span1" @click="isDel = false">否</span>
                  </div>
                </div>
                <div v-else class="edit">
                  <div class="text" @click="editAddress(index)">编辑</div>
                  <div class="text" @click="showDel(item.id,index)">移除</div>
                </div>
              </div>
            </div>
          </div>
          <div class="action-btn">
            <div class="btn" @click="addAddressInfo()">
              <div>添加新地址</div>
              <img class="icon" src="../assets/image/icon/shop-cart-right.svg" />
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "UserInfo",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("此栏为必填项"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback("手机号格式不正确");
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("此栏为必填项"));
      } else if (!/^[0-9][0-9]{5}$/.test(value)) {
        callback("邮编格式不正确");
      } else {
        callback();
      }
    };

    return {
      userid: "",
      isDel: false,
      chooseindex: null,
      data: [],
      addressInfo: {
        id: 0, //地址id
        username: "", //姓名
        phone: "", //姓名
        region: [], //省市区
        province: "", //省
        city: "", //市
        area: "", //县区
        detail: "", //详情
        emailcode: "",
        address: [],
        firstChooseArrdess: false, //默认地址
        firstBillArrdess: false,
        wechatAddress: false
      },
      ruleValidate: {
        username: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        address: [
          {
            required: true,
            message: "此栏为必填项",
            type: "array",
            trigger: "change"
          }
        ],
        emailcode: [
          {
            required: true,
            validator: validateCode
          }
        ],
        detail: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ]
      },

      addressList: [],
      addAddress: false,
      loading: true
    };
  },
  props: {},
  components: {},
  created() {
    document.title = "地址簿" + this.$store.state.titleSuffix;
    this.$utils.CheckOpenIdExist(this);
    var userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.userid = userInfo.openId ? userInfo.openId : userInfo.id;
  },
  mounted() {
    this.getAddressList();
    this.getAllAreas();
    this.$utils.setPathsbysessionStorage(window.location.href)
    this.$gaAction.pageview(document.title, this.$route.path);
    this.$utils.trackData(this,(document.title+','+this.$route.path),'');
  },

  beforeRouteLeave(to, from, next) {
    var state_2 = this.$store.state.RefreshAcountNav;
    this.$store.commit("RefreshAcountNav", !state_2);
    next(true);
  },

  methods: {
    gotest() {

      var state_2 = this.$store.state.RefreshAcountNav;
      this.$store.commit("RefreshAcountNav", !state_2);
    },
    addAddressInfo() {
      var that = this;
      that.addAddress = true;
      that.addressInfo.id = "";
      that.addressInfo.phone = "";
      that.addressInfo.username = "";
      that.addressInfo.province = "";
      that.addressInfo.city = "";
      that.addressInfo.area = "";
      that.addressInfo.detail = "";
      that.addressInfo.emailcode = "";
      that.addressInfo.firstChooseArrdess = false;
      that.addressInfo.address = [];
    },
    editAddress(index) {
      var that = this;
      that.addAddress = true;
      var tempAddress = JSON.stringify(that.addressList);
      var info = JSON.parse(tempAddress).splice(index, 1)[0];
      that.addressInfo.id = info.id;
      that.addressInfo.phone = info.phoneNumber;
      that.addressInfo.username = info.name;
      that.addressInfo.province = info.province;
      that.addressInfo.city = info.city;
      that.addressInfo.district = info.district;
      that.addressInfo.address = [info.province, info.city, info.district];
      that.addressInfo.isDefault = info.isDefault;
      that.addressInfo.detail = info.detailAddress;
      that.addressInfo.emailcode = info.postCode;
      that.addressInfo.firstChooseArrdess = info.default;
    },
    showDel(id, index) {
      this.chooseindex = index;
      this.isDel = true;
      this.addressInfo.id = id;
    },
    async deleteAddress() {
      var url = this.$store.state.API.my.deleteAddress;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      var params = {
        id: this.addressInfo.id,
        merchantId: this.$store.state.storeId,
        openId: OpenId || this.userid
      };
      this.$http.post(url, this.$qs.stringify(params)).then(res => {
        if (res.status == 200 && res.data.message == "success") {
          this.isDel = false;
          this.getAddressList();
          this.$Message.success("删除成功");
        } else if (res.status == 200 && res.data.message == "failure") {
          // address is default
          this.$Message.error("首选收货地址不能删除");
        } else {
          this.$Message.error("删除失败");
        }
      });
    },
    async getAddressList() {
      var url = this.$store.state.API.my.getAddressList;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      var params = {
        openId: OpenId || this.userid
      };
      this.$http.post(url, this.$qs.stringify(params)).then(res => {
        if (res.status == 200 && res.data.message == "success") {
          this.addressList = res.data.returnData;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } else {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      });
    },
    //保存地址
    async saveAddress() {
      var that = this;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      //参数部分 saveAddress
      var url = that.$store.state.API.my.saveAddress;
      var params = {
        addressId: that.addressInfo.id == "0" ? "" : that.addressInfo.id,
        openId: OpenId || this.userid, //userid?
        phoneNumber: that.addressInfo.phone,
        name: that.addressInfo.username,
        province: that.addressInfo.province,
        city: that.addressInfo.city,
        district: that.addressInfo.district,
        detailAddress: that.addressInfo.detail,
        isDefault: that.addressInfo.firstChooseArrdess,
        wechatAddress: that.addressInfo.wechatAddress,
        postCode: that.addressInfo.emailcode
      };

      this.$http.post(url, that.$qs.stringify(params)).then(res => {
        if (res.status == 200 && res.data.message == "success") {
          this.getAddressList();
          this.addAddress = false;
          this.$Message.success("保存成功");
          that.addressInfo.phone = "";
          that.addressInfo.username = "";
          that.addressInfo.province = "";
          that.addressInfo.city = "";
          that.addressInfo.area = "";
          that.addressInfo.detail = "";
          that.addressInfo.emailcode = "";
          that.addressInfo.address = [];
        } else if (res.status == 200 && res.data.message == "地址已存在") {
          this.addAddress = false;
          this.$Message.success("保存成功");
          that.addressInfo.phone = "";
          that.addressInfo.username = "";
          that.addressInfo.province = "";
          that.addressInfo.city = "";
          that.addressInfo.area = "";
          that.addressInfo.detail = "";
          that.addressInfo.emailcode = "";
          that.addressInfo.address = [];
        } else {
          this.$Message.error("保存失败");
        }
      });
    },
    changeTest: function(e, s) {
      this.keyWord = "";
      this.addressInfo.province = s[0].label;
      this.addressInfo.city = s[1].label;
      this.addressInfo.district = s[2].label;
      // this.addressInfo.postCode =
    },
    chooseFirstChooseArrdess() {
      this.addressInfo.firstChooseArrdess = !this.addressInfo
        .firstChooseArrdess;
    },
    chooseBillArrdess() {
      this.addressInfo.firstBillArrdess = !this.addressInfo.firstBillArrdess;
    },
    getAllAreas: function() {
      let url = this.$store.state.API.my.getAllAreas + "?all=true";
      let params = {
        all: ""
      };
      this.$http.get(url).then(res => {
        this.data = [];
        let that = this;
        let list = res.data.returnData;
        for (let i = 0; i < list.length; i++) {
          that.data.push({
            value: list[i].province.name,
            label: list[i].province.name,
            lat: list[i].province.lat,
            lng: list[i].province.lng,
            children: []
          });
          for (let s = 0; s < list[i].cityAndDistricts.length; s++) {
            that.data[i].children.push({
              value: list[i].cityAndDistricts[s].city.name,
              label: list[i].cityAndDistricts[s].city.name,
              lat: list[i].cityAndDistricts[s].city.lat,
              lng: list[i].cityAndDistricts[s].city.lng,
              children: []
            });
            for (
              let j = 0;
              j < list[i].cityAndDistricts[s].district.length;
              j++
            ) {
              that.data[i].children[s].children.push({
                value: list[i].cityAndDistricts[s].district[j].name,
                label: list[i].cityAndDistricts[s].district[j].name,
                lat: list[i].cityAndDistricts[s].district[j].lat,
                lng: list[i].cityAndDistricts[s].district[j].lng
              });
            }
          }
        }
      });
    },
    handleSubmit(name) {
      var that = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          that.saveAddress();
        } else {
          // this.$Message.error("Fail!");
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.address-container {
  // padding: 1rem;
  font-family: ArialNarrow, sans-serif;
  position: relative;
  &.add {
    .title {
      width: 100%;
      padding: 1.6rem 2rem;
      color: #5c5d5f;
      font-size: 1.2rem;
      line-height: 1.67;
      border-bottom: 0.1rem solid #eaeaea;
    }
  }
  .title {
    width: 100%;
    padding: 1.6rem 2rem;
    color: #5c5d5f;
    font-size: 1.2rem;
    line-height: 1.67;
  }

  .address-list {
    .address-item {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      padding: 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;

      .save-address {
        margin-bottom: 0;
        // padding-right: 2rem;
        flex: 0 0 auto;
        width: 10rem;
        &.hide {
          visibility: hidden;
        }
      }
      .address-info {
        display: flex;
        justify-content: space-between;
        width: 88%;

        .address-left {
          display: flex;
          align-items: center;
        }
        .address-right {
          cursor: pointer;
          .edit {
            text-decoration: underline;
          }
          .del-tips {
            text-decoration: none;
            width: 6rem;
            .span1,
            .span2 {
              cursor: pointer;
              text-decoration: underline;
            }
            .span2 {
              padding: 0 0.5rem;
            }
          }
        }
      }
    }

    .no-data {
      padding: 0 2rem;
      padding-top: 2rem;
      color: #5c5d5f;
      font-size: 1.2rem;
      margin-bottom: 2rem;
    }
    .action-btn {
      width: 50%;
      margin-left: 50%;
      padding: 2rem;
      padding-left: 1rem;
    }
  }
  .add-address {
    padding: 0 2rem;
    .title {
      width: 100%;
      padding: 2rem 0rem 2rem;
      color: #5c5d5f;
      font-size: 1.2rem;
      line-height: 1.67;
    }
    .edit {
      display: flex;
      flex-flow: row wrap;

      .edit-item {
        position: relative;
        width: 100%;
        display: flex;
        color: #959595;
        padding: 0 0rem 2rem;
        .save {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          .img {
            font-size: 2rem;
          }
          .text {
            margin-left: 2rem;
          }
        }
        .des {
          color: #959595;
          font-size: 1rem;
          text-align: right;
          margin-top: 1rem;
        }
        .data {
          position: relative;
          display: flex;
          flex-direction: column;
          font-size: inherit;
          flex: 1 0 auto;
          .btn {
            border: 0.1rem solid #5c5d5f;
          }
          .label {
            margin-bottom: 0.5rem;
            font-size: 1rem;
          }
        }
        &.two {
          width: calc(50% - 1rem);
          flex: 0 0 auto !important;
          &.save,
          &.phone {
            margin-left: 2rem;
          }
        }
        &.saves {
          margin-bottom: 4rem;
          margin-top: -2rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &.actions {
          // margin: 1rem 0;
        }
        &.phone-item {
          /deep/.ivu-form-item-content {
            display: flex;
          }
        }
      }
    }
    .edit-btn {
      color: #5c5d5f;
      text-decoration: underline;
      cursor: pointer;
      margin-top: 1rem;
    }

    .canle-btn {
      border: 0.1rem solid #5c5d5f;
      color: #5c5d5f;
      background-color: #fff;
    }
  }
}
/deep/.ivu-form-item {
  margin-bottom: 0;
}
/deep/.ivu-form-item-content {
  font-size: 1.2rem;
  width: 100%;
  line-height: inherit;
}
@media screen and (max-width: 1024px) {
  .address-container {
    border: none;
    .title {
      border-bottom: 0.1rem solid #eaeaea;
    }
    .add-address {
      .title {
        padding: 2rem;
        border-bottom: 0.1rem solid #eaeaea;
      }
    }
    form {
      padding: 2rem;
    }
    .address-list {
      border-top: none;
    }
    .add-address {
      padding: 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .address-container {
    padding-bottom: 15rem;
    &.add {
      padding-bottom: 2rem;
    }
    .title {
      border-top: 0.1rem solid #eaeaea;
      border-bottom: none;
      display: none;
    }

    .add-address .edit {
      padding: 2rem 2rem;
    }

    .add-address .title {
      padding: 2rem 2rem 1.2rem;
    }
    .address-list {
      border-top: 0.1rem solid #eaeaea;
    }
    .address-list .address-item {
      flex-direction: column;
      align-items: initial;
    }
    .address-list .address-item .save-address {
      padding-bottom: 2.5rem;
      &.not-default {
        display: none;
      }
    }
    .address-list .action-btn {
      width: 100%;
      margin-left: initial;
      padding: 2rem;
    }
    .address-list .address-item .address-info {
      width: 100%;
    }

    .address-list .address-item .address-left .save-address {
      width: 9rem;
    }
    .add-address .edit .edit-item.two {
      width: 100%;
      &.actions {
        width: calc(50% - 1rem);
      }

      &.phone {
        margin-left: 0rem;
      }
    }
    .add-address .edit .edit-item .save {
      margin: 2rem 0;
    }
    .add-address .edit .edit-item.saves {
      margin-bottom: 0;
    }
    .user-address {
      max-width: 90%;
    }
  }
}
/deep/.ivu-form-item-error-tip {
  top: -0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AddressList.vue